import React from 'react';
import { OrderReceipt } from '../components/types';

// Define the shape of the context state
interface OrderReceiptContextState {
  orderReceipts: OrderReceipt[];
  mutateOrderReceipt: (rep : OrderReceipt) => void;
  mutateOrderReceipts: (reps : OrderReceipt[]) => void;
}

// Create the context with a default value
const OrderReceiptContext = React.createContext<OrderReceiptContextState | undefined>(undefined);

export default OrderReceiptContext;